"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'HighlightTextarea',
  data: function data() {
    return {
      value: ''
    };
  },
  props: {
    placeholder: {
      type: String,
      required: false,
      default: '请输入'
    },
    text: {
      type: String,
      required: false,
      default: ''
    },
    highlightKey: {
      type: Array,
      require: false,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      required: true,
      default: 'textarea'
    },
    maxHeight: {
      type: Number,
      required: false,
      default: 48
    }
  },
  created: function created() {
    this.value = this.text.replace(/(^\s*)|(\s*$)/g, '').replace(/<br \/>|<br\/>|<br>/g, '\n');
  },
  mounted: function mounted() {
    this.scrollMousewheel();
  },
  computed: {},
  watch: {
    value: function value(newValue) {
      this.$emit('change', newValue);
    }
  },
  methods: {
    highlightHtml: function highlightHtml(str) {
      if ((!str || !this.highlightKey || this.highlightKey.length === 0) && this.type !== 'textarea') {
        return str;
      }
      var rebuild = str;
      rebuild = rebuild.replace(/./g, function (char) {
        var charCode = char.charCodeAt(0);
        var unicode = "\\u" + charCode.toString(16).padStart(4, '0');

        // 检查条件: Unicode 表达式以 '\' 开头并且不是 '\u005c'
        var isSpecialUnicode = unicode.startsWith('\\') && unicode !== "\\u005c";
        var unLegal = unicode.startsWith('\\') && unicode === "\\u2001";

        // 检查条件: 非法 ASCII 范围
        var isIllegalAscii = charCode > 126 || charCode < 32 && ![10, 13, 9].includes(charCode);
        if (isSpecialUnicode && isIllegalAscii) {
          if (unLegal) {
            // 将其 Unicode 字符转义并包裹在 <span> 标签中
            return "<span>".concat(char, "</span>");
          }
          return "<span>".concat(char, "</span>");
        }
        return char;
      });
      // if (this.highlightKey.filter(item => ~str.indexOf(item)).length) {
      //   let regStr = ''
      //   let regExp = null
      //   this.highlightKey.forEach(list => {
      //     regStr = this.escapeString(list)
      //     regExp = new RegExp(regStr, 'g')
      //     rebuild = rebuild.replace(regExp, `<span>${list}</span>`)
      //   })
      // }
      if (this.type === 'textarea') {
        rebuild = rebuild.replace(/\n/g, '<br/>');
        // .replace(/\s/g, '&nbsp;')
        // textarea有滚动条时，div底部不能和textarea重合，故加一个<br/>
        var wrap = this.$refs.textareaBox;
        if (wrap && wrap.scrollHeight > this.maxHeight) {
          rebuild = rebuild + '<br/>';
        }
      }
      console.log(rebuild);
      return rebuild;
    },
    syncScrollTop: function syncScrollTop() {
      var wrap = this.$refs.textareaBox;
      var outerWrap = this.$refs.textareaOuter;
      var outerInner = this.$refs.outerInner;
      if (wrap.scrollHeight > this.maxHeight && outerInner.scrollHeight !== wrap.scrollHeight) {
        outerInner.style.height = "".concat(wrap.scrollHeight, "px");
      }
      if (wrap.scrollTop !== outerWrap.scrollTop) {
        outerWrap.scrollTop = wrap.scrollTop;
      }
    },
    scrollMousewheel: function scrollMousewheel() {
      var _this = this;
      if (this.type === 'input') {
        return;
      }
      this.$nextTick(function () {
        _this.eventHandler('add');
      });
    },
    // 处理字符串中可能对正则有影响的字符
    escapeString: function escapeString(value) {
      var characterss = ['(', ')', '[', ']', '{', '}', '^', '$', '|', '?', '*', '+', '.'];
      var str = value.replace(new RegExp('\\\\', 'g'), '\\\\');
      characterss.forEach(function (characters) {
        var r = new RegExp('\\' + characters, 'g');
        str = str.replace(r, '\\' + characters);
      });
      return str;
    },
    eventHandler: function eventHandler(type) {
      var wrap = this.$refs.textareaBox;
      if (wrap) {
        var mousewheelevt = /Firefox/i.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel';
        wrap["".concat(type, "EventListener")](mousewheelevt, this.syncScrollTop);
        wrap["".concat(type, "EventListener")]('scroll', this.syncScrollTop);
      }
    }
  },
  destroyed: function destroyed() {
    this.eventHandler('remove');
  }
};